import { AxiosInstance, AxiosResponse } from 'axios';

import { AGMS_BASE_URL, AGMS_SERVER } from '../util/environment';

import { AgmsResponseCode } from '../enum/AgmsResponseCode';

import { createAxiosInstance } from './create-axios-instance';

export const axiosInstanceAGMS: AxiosInstance = createAxiosInstance({
  baseURL: `${AGMS_BASE_URL}/${AGMS_SERVER}`,

  shouldRefresh: (response: AxiosResponse): boolean =>
    response.data?.ResponseCode === AgmsResponseCode.NO_AUTHORIZE_REQUEST,
});

export default axiosInstanceAGMS;
